var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"error"},[_c('SvgIcon',{staticClass:"flex-icon mr-1",attrs:{"icon-name":"error"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }